"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Label = styled_components_1.default.span `
  display: inline-block;
  padding: 2px 10px;
  margin-right: 5px;
  background: linear-gradient(
    to bottom right,
    white 10%,
    rgba(255, 228, 128, 255)
  );
  border: 1px solid #333;
  border-radius: 10px;
  font-size: 12px;
  color: #000;
`;
//# sourceMappingURL=label.js.map